<template>
    <div class="tyn-aside tyn-aside-base">
        <div class="tyn-aside-head">
            <div class="tyn-aside-head-text">
                <h3 class="tyn-aside-title tyn-title">Histórico</h3>
                <!--<span class="tyn-subtext">127 itens</span>-->
            </div>
            <div class="tyn-aside-head-tools">
                <ul class="tyn-list-inline gap gap-3">
                    <li>
                        <button class="btn btn-icon btn-success-add btn-md btn-pill" 
                                @click="criarNovo" 
                                title="Novo"
                                style="background: linear-gradient(135deg, #2563eb 0%, #00d084 100%) !important; border: none !important;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                            </svg>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tyn-aside-row pt-0">
            <div class="tabs-simple">
                <router-link to="/Consulta" :class="'tab-simple ' +(nmComponente=='Consulta'?'active':'')" title="Consulta Inteligente">

                    <span>Consulta</span>
                </router-link>

                <router-link to="/Artefato" :class="'tab-simple ' +(nmComponente=='Artefato'?'active':'')" title="Artefato">

                    <span>Artefato</span>
                </router-link>

                <router-link to="/Research" :class="'tab-simple ' +(nmComponente=='Research'?'active':'')" title="Research">

                    <span>Research</span>
                </router-link>

                <router-link to="/ParecerParametrizado" :class="'tab-simple tab-simple--long ' +(nmComponente=='ParecerParametrizado'?'active':'')" title="Parecer Parametrizado">
                    <span>Parecer<br>Parametrizado</span>
                </router-link>

            </div>
        </div>
        <div class="tyn-aside-body" data-simplebar>
            <div class="tyn-aside-search">
                <div class="search-box-modern">
                    <div class="search-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                        </svg>                            
                    </div>
                    <input 
                        type="text" 
                        class="search-input-modern" 
                        id="search" 
                        placeholder="Pesquisar no histórico..." 
                        v-model="dsFiltro" 
                        v-on:keyup.enter="load" 
                        @focusout="load"
                    >
                </div>
            </div>
            <div class="tab-content">
                <div :class="'tab-pane ' +(nmComponente=='Consulta'?'show active':'')" id="tab-1" tabindex="0" role="tabpanel">
                    <div class="tyn-aside-body" data-simplebar>
                        <ul class="tyn-aside-list">
                            <li :class="'tyn-aside-item js-toggle-main '+(item.idConversa == id?'active':'')" v-for="(item,index) in lstConsulta" :key="index" @click="(event) => selecionar(event,item.idConversa,1)"
                                data-bs-toggle="popover" data-bs-placement="right" title="Detalhes"
                        :data-bs-content="getDataBsConsulta(item)"
                                >
                                <div class="tyn-media-group">
                                    <div class="tyn-media tyn-size-sm">
                                        <!--<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-right-text-fill" viewBox="0 0 16 16">
                                            <path d="M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.586a1 1 0 0 1 .707.293l2.853 2.853a.5.5 0 0 0 .854-.353zM3.5 3h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1m0 2.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1m0 2.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1" />
                                        </svg>-->
                                        <img class="img-icone-historico" src="assets/images/sollai/text.png" alt="Consulta">
                                    </div>
                                    <div class="tyn-media-col">
                                        <div class="content">{{item.dsPergunta}}</div>
                                    </div>
                                    <div class="tyn-media-option">
                                        <ul class="tyn-media-option-list">
                                            <li>
                                                <button class="btn btn-icon btn-md btn-pill btn-light" @click="verificaExcluir(item.idConversa,1)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"></path>
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"></path>
                                                    </svg><!-- trash -->
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div :class="'tab-pane ' +(nmComponente=='Artefato'?'show active':'')" id="tab-2" tabindex="0" role="tabpanel">
                    <div class="tyn-aside-body" data-simplebar>
                        <ul class="tyn-aside-list">
                            <li :class="'tyn-aside-item js-toggle-main '+(item.idArtefato == id?'active':'')" v-for="(item,index) in lstArtefato" :key="index" @click="(event) => selecionar(event,item.idArtefato,2)"
                                    data-bs-toggle="popover" data-bs-placement="right" title="Detalhes" :data-bs-content="getDataBsArtefato(item)"
                                >
                                <div class="tyn-media-group">
                                    <div class="tyn-media tyn-size-sm">
                                        <img class="img-icone-historico" src="assets/images/sollai/leis.png" alt="Artefato">
                                    </div>
                                    <div class="tyn-media-col">
                                        <div class="content">{{item.dsNome}}</div>
                                    </div>
                                    <div class="tyn-media-option">
                                        <ul class="tyn-media-option-list">
                                            <li>
                                                <button class="btn btn-icon btn-md btn-pill btn-light" @click="verificaExcluir(item.idArtefato,2)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"></path>
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"></path>
                                                    </svg><!-- trash -->
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div :class="'tab-pane ' +(nmComponente=='Research'?'show active':'')" id="tab-3" tabindex="0" role="tabpanel">
                    <div class="tyn-aside-body" data-simplebar>
                        <ul class="tyn-aside-list">
                            <li :class="'tyn-aside-item js-toggle-main '+(item.idResearch == id?'active':'')" v-for="(item,index) in lstResearch" :key="index" @click="(event) => selecionar(event,item.idResearch,3)"
                                data-bs-toggle="popover" data-bs-placement="right" title="Detalhes" :data-bs-content="getDataBsResearch(item)"
                                >
                                <div class="tyn-media-group">
                                    <div class="tyn-media tyn-size-sm">
                                        <img class="img-icone-historico" src="assets/images/sollai/search.png" alt="Research">
                                    </div>
                                    <div class="tyn-media-col">
                                        <div class="content">{{item.dsNome}}</div>
                                    </div>
                                    <div class="tyn-media-option">
                                        <ul class="tyn-media-option-list">
                                            <li>
                                                <button class="btn btn-icon btn-md btn-pill btn-light" @click="verificaExcluir(item.idResearch,3)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"></path>
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"></path>
                                                    </svg><!-- trash -->
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div :class="'tab-pane ' +(nmComponente=='ParecerParametrizado'?'show active':'')" id="tab-4" tabindex="0" role="tabpanel">
                    <div class="tyn-aside-body" data-simplebar>
                        <ul class="tyn-aside-list">
                            <li :class="'tyn-aside-item js-toggle-main '+(item.idParecerParametrizado == id?'active':'')" v-for="(item,index) in lstParecerParametrizado" :key="index" @click="(event) => selecionar(event,item.idParecerParametrizado,4)"
                                data-bs-toggle="popover" data-bs-placement="right" title="Detalhes" :data-bs-content="getDataBsParecerParametrizado(item)"
                                >
                                <div class="tyn-media-group">
                                    <div class="tyn-media tyn-size-sm">
                                        <img class="img-icone-historico" src="assets/images/sollai/parecerparametrizado.png" alt="Parecer Parametrizado">
                                    </div>
                                    <div class="tyn-media-col">
                                        <div class="content">{{item.dsNome}}</div>
                                    </div>
                                    <div class="tyn-media-option">
                                        <ul class="tyn-media-option-list">
                                            <li>
                                                <button class="btn btn-icon btn-md btn-pill btn-light" @click="verificaExcluir(item.idParecerParametrizado,4)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"></path>
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"></path>
                                                    </svg><!-- trash -->
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                
            </div>
        </div>
        <div class="tyn-aside-foot">
            <div class="w-100">
                <ul class="row justify-content-center gx-3">
                    <li class="col-12">
                        <template v-if="utilizacoes">
                            <p class="px-3 mb-1 text-center">
                                Total Consultas: <span class="text-muted">{{utilizacoes.qtdRealizados}}</span>/<span class="text-success fw-bold">{{utilizacoes.qtdLiberados}}</span>
                            </p>
                            <div class="px-3">
                                <div class="progress mt-1 custom-progress">
                                    <div class="progress-bar progress-bar-color" role="progressbar" :style="{width: percentual+'%'}"
                                         aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">{{txtPercentual}}</div>
                                </div>
                            </div>
                        </template>
                        <template v-if="utilizacoesArtefato">
                            <p class="px-3 mb-1 text-center">
                                Total Artefatos: <span class="text-muted">{{utilizacoesArtefato.qtdRealizados}}</span>/<span class="text-success fw-bold">{{utilizacoesArtefato.qtdLiberados}}</span>
                            </p>
                            <div class="px-3">
                                <div class="progress mt-1 custom-progress">
                                    <div class="progress-bar progress-bar-color" role="progressbar" :style="{width: percentualArtefato+'%'}"
                                         aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">{{txtPercentualArtefato}}</div>
                                </div>
                            </div>
                        </template>
                        <template v-if="utilizacoesResearch">
                            <p class="px-3 mb-1 text-center">
                                Total Researchs: <span class="text-muted">{{utilizacoesResearch.qtdRealizados}}</span>/<span class="text-success fw-bold">{{utilizacoesResearch.qtdLiberados}}</span>
                            </p>
                            <div class="px-3">
                                <div class="progress mt-1 custom-progress">
                                    <div class="progress-bar progress-bar-color" role="progressbar" :style="{width: percentualResearch+'%'}"
                                         aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">{{txtPercentualResearch}}</div>
                                </div>
                            </div>
                        </template>
                        <template v-if="utilizacoesParecerParametrizado">
                            <p class="px-3 mb-1 text-center">
                                Total Pareceres Parametrizados: <span class="text-muted">{{utilizacoesParecerParametrizado.qtdRealizados}}</span>/<span class="text-success fw-bold">{{utilizacoesParecerParametrizado.qtdLiberados}}</span>
                            </p>
                            <div class="px-3">
                                <div class="progress mt-1 custom-progress">
                                    <div class="progress-bar progress-bar-color" role="progressbar" :style="{width: percentualParecerParametrizado+'%'}"
                                         aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">{{txtPercentualParecerParametrizado}}</div>
                                </div>
                            </div>
                        </template>
                        
                    </li>
                </ul><!-- .row -->
            </div><!-- w-100 -->
        </div><!-- .tyn-aside-foot -->

    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'
    import Swal from 'sweetalert2'

    export default {
        name: 'Historico',
        components: {},
        props: {
            nmComponente: String,
            seleciona: Function,
            exclui: Function,
            reload: Boolean,
            novo: Function,
            id: Number,
        },
        computed: {
            user() {
                return this.$store.state.user
            },
        },
        data: function () {
            return {
                lstConsulta: [],
                lstArtefato: [],
                lstResearch: [],
                lstParecerParametrizado: [],

                dsFiltro: null,


                utilizacoes: null,
                percentual: 0,
                txtPercentual: "",

                utilizacoesArtefato: null,
                percentualArtefato: 0,
                txtPercentualArtefato: "",


                utilizacoesResearch: null,
                percentualResearch: 0,
                txtPercentualResearch: "",

                utilizacoesParecerParametrizado: null,
                percentualParecerParametrizado: 0,
                txtPercentualParecerParametrizado: "",

            }
        },
        methods: {
            load() {
                this.utilizacoes = null;
                this.percentual = 0;
                this.txtPercentual = "";

                this.utilizacoesArtefato = null;
                this.percentualArtefato = 0;
                this.txtPercentualArtefato = "";

                this.utilizacoesResearch = null;
                this.percentualResearch = 0;
                this.txtPercentualResearch = "";

                this.utilizacoesParecerParametrizado = null;
                this.percentualParecerParametrizado = 0;
                this.txtPercentualParecerParametrizado = "";


                switch (this.nmComponente) {
                    case 'Consulta':
                        this.carregaHistoricoConsulta();
                        this.carregaUtilizacoes();
                        break;
                    case 'Artefato':
                        this.carregaUtilizacoesArtefatos();
                        this.carregaHistoricoArtefato();
                        break;
                    case 'Research':
                        this.carregaHistoricoResearch();
                        this.carregaUtilizacoesResearchs();
                        break;

                    case 'ParecerParametrizado':
                        this.carregaHistoricoParecerParametrizado();
                        this.carregaUtilizacoesParecerParametrizado();
                        break;

                    default:
                        this.carregaHistoricoConsulta();
                        this.carregaHistoricoArtefato();
                        this.carregaHistoricoResearch();
                        this.carregaHistoricoParecerParametrizado();

                        this.carregaUtilizacoes();
                        this.carregaUtilizacoesArtefatos();
                        this.carregaUtilizacoesResearchs();
                        this.carregaUtilizacoesParecerParametrizado();
                        break;
                }
            },

            getDataBsConsulta(item) {
                let tpPergunta = (item.tpPergunta == "RO" || item.tpPergunta == "Resposta Objetiva" ? "Resposta Objetiva" : "Parecer Técnico");
                //let status = (item.status == "Finalizada" ? 'text-success' : 'text-danger');

                return ` <span class="mb-0"><strong>Tipo:</strong> ${tpPergunta}</span> 
                 <span class="mb-0"><strong>Data:</strong> ${item.dtPergunta}</span> 
                <p class="mb-0"><strong>Pergunta:</strong> ${item.dsPergunta}</p> `;
            },
            getDataBsArtefato(item) {
                return ` <span class="mb-0"><strong>Tipo:</strong> ${item.nmModelo}</span> 
                 <span class="mb-0"><strong>Data:</strong> ${item.dtInclusao}</span> 
                 <span class="mb-0"><strong>Legislação:</strong> ${item.nmLegislacao}</span> 
                `;
            },

            getDataBsResearch(item) {
                return ` <span class="mb-0"><strong>Tipo:</strong> ${item.nmTipoResearch}</span> 
                 <span class="mb-0"><strong>Data:</strong> ${item.dtInclusao}</span> 
                `;
            },

            getDataBsParecerParametrizado(item) {
                return ` <span class="mb-0"><strong>Legislacao:</strong> ${item.nmLegislacao}</span> 
                 <span class="mb-0"><strong>Modelo:</strong> ${item.nmModelo || ''}</span>
                 <span class="mb-0"><strong>Data:</strong> ${item.dtInclusao}</span> 
                `;
            },

            

            montaPopover() {
                var popovers = document.querySelectorAll(".popover");
                // Itera sobre cada elemento e remove-o
                popovers.forEach(function (popover) {
                    popover.remove();
                });

                this.$nextTick(function () {
                    var popoverTriggerList = document.querySelectorAll(
                        '[data-bs-toggle="popover"]',
                    );// eslint-disable-line no-console

                    if (popoverTriggerList.length > 0) {
                        [].slice
                            .call(popoverTriggerList)
                            .map(function (popoverTriggerEl) {
                                return new window.bootstrap.Popover(popoverTriggerEl, {
                                    trigger: "hover",
                                    boundary: "window",
                                    html: true,
                                    customClass: 'custom-popover'
                                    //placement: "right",
                                });
                            });
                    }
                });
            },

            carregaHistoricoConsulta() {
                let $this = this;
                axios.get(`${urlApi}/Parecer/GetHistorico`, { showLoading: false, params: { dsTermo: this.dsFiltro } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstConsulta = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];
                                item.dtPergunta = moment(item.dtInclusao).format('DD/MM/YYYY [às] HH:mm');

                                if ($this.user.usuario.dsLogin.trim() == item.dsLogin.trim()) {
                                    $this.lstConsulta.push(item);
                                }                                
                            }
                            $this.montaPopover();
                        } else {
                            avisoErro("Não foi possível carregar suas perguntas.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar suas perguntas.");
                        }
                    });
            },


            carregaHistoricoArtefato() {
                let $this = this;
                axios.get(`${urlApi}/Artefato/GetHistorico`, { showLoading: false, params: { dsTermo: this.dsFiltro } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstArtefato = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];
                                item.dtInclusao = moment(item.dtInclusao).format('DD/MM/YYYY [às] HH:mm');

                                if ($this.user.usuario.dsLogin.trim() == item.dsLogin.trim()) {
                                    $this.lstArtefato.push(item);
                                }                                
                            }
                            $this.montaPopover();
                        } else {
                            avisoErro("Não foi possível carregar seus artefatos.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar seus artefatos.");
                        }
                    });
            },

            carregaHistoricoResearch() {
                let $this = this;
                axios.get(`${urlApi}/Research/Get`, { showLoading: false, params: { dsTermo: this.dsFiltro } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstResearch = [];
                            const resultado = res.data.data.resultados;
                            for (let i = 0; i < resultado.rows.length; i++) {
                                var item = resultado.rows[i];

                                var status = '';
                                if (item.lstResearchMovimento.length > 0) {
                                    status = item.lstResearchMovimento[item.lstResearchMovimento.length - 1].dsMovimento;
                                }

                                var research = {
                                    idResearch: item.research.idResearch,
                                    dsLogin: item.research.dsLogin,
                                    usuario: item.usuario.nmUsuario,
                                    dsNome: item.research.dsNome,
                                    dtInclusao: moment(item.research.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                    nmTipoResearch: item.tipoResearch.dsNome,
                                    status: status,
                                };

                                if ($this.user.usuario.dsLogin.trim() == research.dsLogin.trim()) {
                                    $this.lstResearch.push(research);
                                }                                
                            }
                            $this.montaPopover();
                        } else {
                            avisoErro("Não foi possível carregar suas solicitações.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar ssuas solicitações.");
                        }
                    });
            },

            carregaHistoricoParecerParametrizado() {
                let $this = this;
                axios.get(`${urlApi}/ParecerParametrizado/GetHistorico`, { showLoading: false, params: { dsTermo: this.dsFiltro } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstParecerParametrizado = [];
                            const resultado = res.data.data;
                            if (!resultado || !resultado.rows) {
                                return;
                            }
                            for (let i = 0; i < resultado.rows.length; i++) {
                                var item = resultado.rows[i];
                                var dados = item.parecerParametrizado || item;
                                var parecer = {
                                    idParecerParametrizado: dados.idParecerParametrizado,
                                    dsLogin: dados.dsLogin,
                                    dsNome: dados.dsNome,
                                    dtInclusao: moment(dados.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                    nmLegislacao: item.legislacao ? item.legislacao.dsNome : '',
                                    nmModelo: item.nmModelo || '',
                                };

                                if ($this.user.usuario.dsLogin.trim() == parecer.dsLogin.trim()) {
                                    $this.lstParecerParametrizado.push(parecer);
                                }
                            }
                            $this.montaPopover();
                        } else {
                            avisoErro("Não foi possível carregar seus Parecer Parametrizado.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar seus Parecer Parametrizado.");
                        }
                    });
            },

            carregaUtilizacoes() {
                let $this = this;
                axios.get(`${urlApi}/Parecer/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            $this.utilizacoes = res.data.data;
                            if ($this.utilizacoes.qtdLiberados != 'Ilimitado') {
                                try {
                                    this.percentual = parseInt(parseInt($this.utilizacoes.qtdRealizados) * 100 / parseInt($this.utilizacoes.qtdLiberados));
                                    this.txtPercentual = this.percentual + "%";
                                } catch {
                                    console.log("")
                                }
                            } else {
                                this.percentual = 100;
                                this.txtPercentual = "Ilimitado";
                            }
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de perguntas.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        }
                    });
            },
            carregaUtilizacoesArtefatos() {
                let $this = this;
                axios.get(`${urlApi}/Artefato/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            $this.utilizacoesArtefato = res.data.data;
                            if ($this.utilizacoesArtefato.qtdLiberados != 'Ilimitado') {
                                try {
                                    this.percentualArtefato = parseInt(parseInt($this.utilizacoesArtefato.qtdRealizados) * 100 / parseInt($this.utilizacoesArtefato.qtdLiberados));
                                    this.txtPercentualArtefato = this.percentualArtefato + "%";
                                } catch {
                                    console.log("")
                                }

                            } else {
                                this.percentualArtefato = 100;
                                this.txtPercentualArtefato = "Ilimitado";
                            }
                        } else {
                            avisoErro("Não foi possível a quantidade de artefatos.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        }
                    });
            },
            carregaUtilizacoesResearchs() {
                let $this = this;
                axios.get(`${urlApi}/Research/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            $this.utilizacoesResearch = res.data.data;
                            if ($this.utilizacoesResearch.qtdLiberados != 'Ilimitado') {
                                try {
                                    this.percentualResearch = parseInt(parseInt($this.utilizacoesResearch.qtdRealizados) * 100 / parseInt($this.utilizacoesResearch.qtdLiberados));
                                    this.txtPercentualResearch = this.percentualResearch + "%";
                                } catch {
                                    console.log("")
                                }

                            } else {
                                this.percentualResearch = 100;
                                this.txtPercentualResearch = "Ilimitado";
                            }
                        } else {
                            avisoErro("Não foi possível a quantidade de researchs.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        }
                    });
            },
            carregaUtilizacoesParecerParametrizado() {
                let $this = this;
                axios.get(`${urlApi}/ParecerParametrizado/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            $this.utilizacoesParecerParametrizado = res.data.data;
                            if ($this.utilizacoesParecerParametrizado.qtdLiberados != 'Ilimitado') {
                                try {
                                    this.percentualParecerParametrizado = parseInt(parseInt($this.utilizacoesParecerParametrizado.qtdRealizados) * 100 / parseInt($this.utilizacoesParecerParametrizado.qtdLiberados));
                                    this.txtPercentualParecerParametrizado = this.percentualParecerParametrizado + "%";
                                } catch {
                                    console.log("")
                                }

                            } else {
                                this.percentualParecerParametrizado = 100;
                                this.txtPercentualParecerParametrizado = "Ilimitado";
                            }
                        } else {
                            avisoErro("Não foi possível a quantidade de Parecer Parametrizado.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        }
                    });
            },

            selecionar(e, id,tipo) {
                this.seleciona(id, tipo);
                document.getElementById('tynMain').classList.toggle('main-shown');
            },

            verificaExcluir(id, tipo) {
                let $this = this;
                Swal.fire({
                    title: 'Tem certeza que deseja remover?',
                    text: 'Esta operação não poderá ser desfeita.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não',
                    confirmButtonColor: '#83A431',
                }).then((result) => {
                    if (result.isConfirmed) {
                        $this.excluir(id, tipo)
                    }
                })
            },

            excluir(id, tipo) {
                let $this = this;
                switch (tipo) {
                    case 1:
                        // Consulta
                        axios.delete(`${urlApi}/Parecer/Delete`, { params: { id: id } })
                            .then(res => {
                                if (res.data.success) {
                                    $this.load();
                                    avisoToast("Pergunta removida com sucesso");
                                } else {
                                    avisoErro("Não foi remover a pergunta.");
                                }
                            })
                            .catch(res => {
                                if (res.data != undefined) {
                                    avisoErro(res.data);
                                } else {
                                    avisoErro("Não foi remover a pergunta.");
                                }
                            });
                        break;

                    case 2:
                        axios.delete(`${urlApi}/Artefato/Delete`, { params: { id: id } })
                            .then(res => {
                                if (res.data.success) {
                                    $this.load();
                                    avisoToast("Artefato removido com sucesso");
                                } else {
                                    avisoErro("Não foi remover o artefato.");
                                }
                            })
                            .catch(res => {
                                if (res.data != undefined) {
                                    avisoErro(res.data);
                                } else {
                                    avisoErro("Não foi remover o artefato.");
                                }
                            });
                        break;

                    case 3:
                        axios.delete(`${urlApi}/Research/Delete`, { params: { id: id } })
                            .then(res => {
                                if (res.data.success) {
                                    $this.load();
                                    avisoToast("Research removido com sucesso");
                                } else {
                                    avisoErro("Não foi remover o research.");
                                }
                            })
                            .catch(res => {
                                if (res.data != undefined) {
                                    avisoErro(res.data);
                                } else {
                                    avisoErro("Não foi remover o research.");
                                }
                            });
                        break;

                    case 4:
                        axios.delete(`${urlApi}/ParecerParametrizado/Delete`, { params: { id: id } })
                            .then(res => {
                                if (res.data.success) {
                                    $this.load();
                                    avisoToast("Parecer Parametrizado removido com sucesso");
                                } else {
                                    avisoErro("Não foi remover o Parecer Parametrizado.");
                                }
                            })
                            .catch(res => {
                                if (res.data != undefined) {
                                    avisoErro(res.data);
                                } else {
                                    avisoErro("Não foi remover o Parecer Parametrizado.");
                                }
                            });
                        break;

                }
            },

            criarNovo() {
                this.novo();
                document.getElementById('tynMain').classList.toggle('main-shown');
            },
        },
        mounted: function () {
            this.load();
        },
        watch: {
            reload: function () {
                this.load();
            },
            dsFiltro: function () {
                if (this.dsFiltro.length > 3) {
                    this.load();
                } else {
                    if (this.dsFiltro == "") {
                        this.load();
                    }
                }
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    /* PROGRESS BAR */
    .single-progress + .single-progress {
        margin-top: 40px;
    }

    .single-progress {
        position: relative;
        overflow: hidden;
    }

    .single-progress .title {
        font-size: 18px;
        font-weight: 400;
        margin-bottom: 0;
        color: #acacac;
        color: #0051ad;
        letter-spacing: 0.5px;
        margin-bottom: 18px;
    }

    .progress {
        height: 6px;
        overflow: visible;
        background-color: #0f1021;
        border-radius: 10px;
    }

    .progress .progress-bar {
        border-radius: 10px;
        width: 0;
        height: 100%;
        background-color: #0051ad;
        transition: width 0.5s ease;
        overflow: visible;
    }

    .progress .progress-bar.bar-color-2 {
        background: rgb(251, 83, 67);
    }

    .progress .progress-bar.bar-color-3 {
        background: #e33fa1;
    }

    .progress .progress-bar.bar-color-4 {
        background: #6549d5;
    }

    .progress .progress-bar.bar-gradiand {
        background: radial-gradient( circle farthest-corner at 0% 0%, #0051ad 25%, #0051ad 45%, #0051ad 65%, #0051ad 85% );
    }

    .progress .progress-number {
        position: absolute;
        font-size: 14px;
        top: 0;
        line-height: 24px;
        right: 0;
        z-index: 1;
    }

    .progress-info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 18px;
    }

    .progress-info .title {
        font-size: 18px;
        font-weight: 400;
        margin-bottom: 0;
        color: var(--color-body);
        letter-spacing: 0.5px;
    }

    .progress-info span.progress-number {
        font-size: 14px;
        color: var(--color-body);
    }

    .no-radius .progress {
        border-radius: 0;
    }

    .no-radius .progress .progress-bar {
        border-radius: 0;
    }

    .large-size .progress {
        height: 20px;
    }

    .progress-bar-color {
        color: white;
        background: rgb(0, 81, 173);
        background: linear-gradient( 90deg, rgba(0, 81, 173, 1) 0%, rgba(0, 191, 81, 1) 100% );
    }
    .custom-progress {
        height: 25px;
    }

    .custom-progress .progress-bar {
        height: 25px;
        font-size: 1.2em;
    }

    .img-icone-historico {
        max-width: 20px;
        height: auto;
    }

    [data-bs-theme=dark] .img-icone-historico {
        filter: invert(1)
    }

    /* Botão de Adicionar Novo */
    .btn-success-add {
        background: linear-gradient(135deg, #2563eb 0%, #00d084 100%) !important;
        color: white !important;
        border: none !important;
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .btn-success-add:hover,
    .btn-success-add:focus,
    .btn-success-add:active {
        background: linear-gradient(135deg, #1d4ed8 0%, #00bf51 100%) !important;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35) !important;
        color: white !important;
        border-color: transparent !important;
    }

    .btn-success-add svg {
        fill: white !important;
    }

    [data-bs-theme=dark] .btn-success-add {
        background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%) !important;
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
    }

    [data-bs-theme=dark] .btn-success-add:hover,
    [data-bs-theme=dark] .btn-success-add:focus,
    [data-bs-theme=dark] .btn-success-add:active {
        background: linear-gradient(135deg, #2563eb 0%, #059669 100%) !important;
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4) !important;
        border-color: transparent !important;
    }

    /* ========================================
       CAMPO DE PESQUISA MODERNO
       ======================================== */
    
    .tyn-aside-search {
        padding: 0.75rem 1rem;
        margin-bottom: 0.5rem;
    }

    .search-box-modern {
        position: relative;
        display: flex;
        align-items: center;
        background: linear-gradient(135deg, rgba(248, 249, 250, 0.95) 0%, rgba(233, 236, 239, 0.95) 100%);
        border: 2px solid rgba(31, 123, 255, 0.15);
        border-radius: 14px;
        padding: 0.65rem 1rem;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

        &:hover {
            border-color: rgba(31, 123, 255, 0.3);
            box-shadow: 0 4px 12px rgba(31, 123, 255, 0.15);
            transform: translateY(-1px);
        }

        &:focus-within {
            border-color: #1f7bff;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.1),
                        0 4px 12px rgba(31, 123, 255, 0.2);
            transform: translateY(-2px);
            background: #ffffff;
        }
    }

    .search-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.75rem;
        flex-shrink: 0;
        color: #6c757d;
        transition: all 0.3s ease;

        svg {
            transition: all 0.3s ease;
        }
    }

    .search-box-modern:focus-within .search-icon {
        color: #1f7bff;

        svg {
            transform: scale(1.1);
        }
    }

    .search-input-modern {
        flex: 1;
        border: none;
        background: transparent;
        outline: none;
        padding: 0.25rem 0;
        font-size: 0.95rem;
        color: #2d3748;
        font-weight: 500;

        &::placeholder {
            color: #a0aec0;
            font-weight: 400;
        }

        &:focus {
            outline: none;
        }
    }

    /* ========================================
       TABS COMPACTAS E MINIMALISTAS
       ======================================== */
    
    .tyn-aside-row {
        padding: 0.5rem 0.75rem 0 0.75rem;
    }

    .tabs-simple {
        display: flex;
        gap: 0.35rem;
        padding: 0.35rem;
        background: rgba(233, 236, 239, 0.25);
        border-radius: 10px;
        margin-bottom: 0.5rem;
    }

    .tab-simple {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.35rem;
        padding: 0.45rem 0.3rem;
        min-height: 2.7rem;
        background: white;
        border: 1px solid #e9ecef;
        border-radius: 7px;
        color: #6c757d;
        font-size: 0.72rem;
        font-weight: 600;
        text-decoration: none;
        text-align: center;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;

        svg {
            flex-shrink: 0;
            transition: all 0.25s ease;
        }

        span {
            white-space: normal;
            line-height: 1.15;
            overflow: visible;
            text-overflow: unset;
        }

        &.tab-simple--long {
            flex: 1.35;
            font-size: 0.65rem;
            letter-spacing: -0.01em;
        }

        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 2px;
            background: linear-gradient(90deg, #1f7bff 0%, #00d084 100%);
            transform: scaleX(0);
            transition: transform 0.25s ease;
        }

        &:hover {
            background: rgba(31, 123, 255, 0.05);
            border-color: #1f7bff;
            color: #1f7bff;
            transform: translateY(-1px);

            svg {
                transform: scale(1.05);
            }

            &::after {
                transform: scaleX(1);
            }
        }

        &.active {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: transparent;
            color: white;
            box-shadow: 0 2px 8px rgba(31, 123, 255, 0.25);

            svg {
                filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
            }

            &::after {
                display: none;
            }
        }
    }

    /* Dark mode tabs */
    [data-bs-theme=dark] .tabs-simple {
        background: rgba(15, 23, 42, 0.4);
    }

    [data-bs-theme=dark] .tab-simple {
        background: #1e293b;
        border-color: #334155;
        color: #cbd5e1;

        &:hover {
            background: rgba(59, 130, 246, 0.1);
            border-color: #3b82f6;
            color: #60a5fa;
        }

        &.active {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
        }
    }

    /* ========================================
       ITEMS DO HISTÓRICO MODERNIZADOS
       ======================================== */
    
    .tyn-aside-item {
        border-radius: 10px;
        margin-bottom: 0.5rem;
        padding: 0.75rem;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: 2px solid transparent;
        cursor: pointer;

        &:hover {
            background: linear-gradient(135deg, rgba(31, 123, 255, 0.05) 0%, rgba(0, 208, 132, 0.05) 100%);
            border-color: rgba(31, 123, 255, 0.15);
            transform: translateX(4px);
            box-shadow: 0 2px 8px rgba(31, 123, 255, 0.1);

            .content {
                color: #1f7bff;
            }
        }

        &.active {
            background: linear-gradient(135deg, rgba(31, 123, 255, 0.12) 0%, rgba(0, 208, 132, 0.12) 100%);
            border-color: #1f7bff;
            box-shadow: 0 3px 10px rgba(31, 123, 255, 0.2);
            transform: translateX(6px);

            .content {
                color: #1f7bff;
                font-weight: 600;
            }

            .img-icone-historico {
                filter: brightness(1.2);
            }
        }
    }

    .content {
        font-size: 0.9rem;
        line-height: 1.4;
        color: #2d3748;
        transition: all 0.3s ease;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .tyn-media-group {
        display: flex;
        align-items: center;
        gap: 0.75rem;
    }

    .tyn-media {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.1) 0%, rgba(0, 208, 132, 0.1) 100%);
        border-radius: 8px;
        transition: all 0.3s ease;
    }

    .tyn-aside-item:hover .tyn-media {
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.15) 0%, rgba(0, 208, 132, 0.15) 100%);
        transform: scale(1.05);
    }

    .tyn-aside-item.active .tyn-media {
        background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.3);
    }

    /* Dark mode items */
    [data-bs-theme=dark] .tyn-aside-item {
        &:hover {
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.08) 0%, rgba(16, 185, 129, 0.08) 100%);
            border-color: rgba(59, 130, 246, 0.2);
        }

        &.active {
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(16, 185, 129, 0.15) 100%);
            border-color: #3b82f6;
        }

        .content {
            color: #cbd5e1;
        }

        &:hover .content,
        &.active .content {
            color: #60a5fa;
        }
    }

    /* Botão de lixeira modernizado */
    .btn-pill.btn-light {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: 1px solid #e9ecef;

        &:hover {
            background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
            border-color: transparent;
            transform: scale(1.1);
            box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);

            svg {
                fill: white !important;
            }
        }
    }

    /* Progress bars modernizadas */
    .custom-progress {
        height: 28px;
        border-radius: 12px;
        background: rgba(233, 236, 239, 0.5);
        overflow: hidden;
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .custom-progress .progress-bar {
        height: 28px;
        font-size: 0.875rem;
        font-weight: 600;
        border-radius: 12px;
        background: linear-gradient(90deg, #1f7bff 0%, #00d084 100%);
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.3);
        display: flex;
        align-items: center;
        justify-content: center;
        transition: width 0.5s ease;
    }

    .progress-bar-color {
        color: white;
        background: linear-gradient(90deg, #1f7bff 0%, #00d084 100%) !important;
    }

    /* Rodapé com estatísticas */
    .tyn-aside-foot {
        border-top: 2px solid rgba(31, 123, 255, 0.1);
        padding: 1rem;
        background: linear-gradient(135deg, rgba(248, 249, 250, 0.5) 0%, rgba(233, 236, 239, 0.5) 100%);

        p {
            font-size: 0.9rem;
            font-weight: 500;
            color: #2d3748;
        }

        .text-success {
            background: linear-gradient(135deg, #00d084 0%, #00bf51 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }
    }

    /* Popover customizado */
    :deep(.custom-popover) {
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        border: 2px solid rgba(31, 123, 255, 0.2);

        .popover-header {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            color: white;
            border-radius: 10px 10px 0 0;
            font-weight: 600;
        }

        .popover-body {
            font-size: 0.9rem;
            line-height: 1.6;
        }
    }

    /* ========================================
       RESPONSIVIDADE
       ======================================== */
    
    @media (max-width: 767px) {
        .btn-success-add {
            width: 36px;
            height: 36px;
            padding: 0.5rem;
        }

        .btn-success-add svg {
            width: 14px;
            height: 14px;
        }

        /* Tabs compactas mobile */
        .tyn-aside-row {
            padding: 0.4rem 0.5rem 0 0.5rem;
        }

        .tabs-simple {
            padding: 0.3rem;
            gap: 0.3rem;
        }

        .tab-simple {
            padding: 0.45rem 0.3rem;
            font-size: 0.7rem;
            gap: 0.3rem;

            svg {
                width: 12px;
                height: 12px;
            }

        }

        .search-box-modern {
            padding: 0.55rem 0.875rem;
            border-radius: 12px;
        }

        .search-input-modern {
            font-size: 0.875rem;
        }

        .search-icon svg {
            width: 16px;
            height: 16px;
        }

        .tyn-aside-item {
            padding: 0.65rem;
        }

        .content {
            font-size: 0.85rem;
        }

        .tyn-media {
            width: 32px;
            height: 32px;
        }

        .img-icone-historico {
            max-width: 18px;
        }

        .custom-progress {
            height: 24px;
        }

        .custom-progress .progress-bar {
            height: 24px;
            font-size: 0.8rem;
        }

        .tyn-aside-foot p {
            font-size: 0.85rem;
        }
    }

    @media (min-width: 768px) and (max-width: 1300px) {
        .btn-success-add {
            width: 40px;
            height: 40px;
        }

        .search-box-modern {
            padding: 0.6rem 0.95rem;
        }

        .search-input-modern {
            font-size: 0.9rem;
        }

        /* Tabs compactas tablet */
        .tab-simple {
            font-size: 0.68rem;
            padding: 0.4rem 0.25rem;
            min-height: 2.6rem;

            svg {
                width: 13px;
                height: 13px;
            }

            &.tab-simple--long {
                font-size: 0.62rem;
            }
        }
    }

    /* ============================================
       DARK THEME - Search Box
       ============================================ */

    [data-bs-theme="dark"] .search-box-modern {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(96, 165, 250, 0.2);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

        &:hover {
            border-color: rgba(96, 165, 250, 0.35);
            box-shadow: 0 4px 12px rgba(96, 165, 250, 0.2);
        }

        &:focus-within {
            background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
            border-color: #60a5fa;
            box-shadow: 0 0 0 4px rgba(96, 165, 250, 0.15),
                        0 4px 12px rgba(96, 165, 250, 0.3);
        }
    }

    [data-bs-theme="dark"] .search-icon {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .search-box-modern:focus-within .search-icon {
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .search-input-modern {
        color: #f3f4f6;
        font-weight: 500;

        &::placeholder {
            color: #6b7280;
        }
    }

    /* Footer */
    [data-bs-theme="dark"] .tyn-aside-foot {
        background: linear-gradient(135deg, #1a1d29 0%, #1e2330 100%);
        border-top-color: rgba(96, 165, 250, 0.2);

        p {
            color: #e5e7eb;
        }

        .text-success {
            background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }
    }

    [data-bs-theme="dark"] .custom-progress {
        background: #0f1117;
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.4);
    }

    [data-bs-theme="dark"] .progress-bar-color {
        background: linear-gradient(90deg, #3b82f6 0%, #10b981 100%) !important;
    }

    /* Title */
    [data-bs-theme="dark"] .tyn-aside-title {
        color: #f9fafb;
    }

    /* Media Dark */
    [data-bs-theme="dark"] .tyn-media {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);
    }

    [data-bs-theme="dark"] .tyn-aside-item:hover .tyn-media {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(16, 185, 129, 0.2) 100%);
    }

    [data-bs-theme="dark"] .tyn-aside-item.active .tyn-media {
        background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
    }

    /* Popover Dark */
    [data-bs-theme="dark"] :deep(.custom-popover) {
        background: #1e2330;
        border-color: rgba(96, 165, 250, 0.3);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);

        .popover-header {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
        }

        .popover-body {
            background: #1e2330;
            color: #e5e7eb;
        }
    }

    /* Trash button dark */
    [data-bs-theme="dark"] .btn-pill.btn-light {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(255, 255, 255, 0.12);

        svg {
            fill: #e5e7eb !important;
        }

        &:hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            border-color: transparent;
            box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);

            svg {
                fill: white !important;
            }
        }
    }

</style>

